

export const unifiedCheckoutOptions = (theme: any, displaySavedPaymentMethods = true) => {
    const unifiedCheckoutOptions = {
    appearance: {
      rules: {
        '.Tab': {
          backgroundColor: theme.palette.background.primaryV2,
          color: theme.palette.text.primary,
          borderRadius: '5px',
          fontWeight: 'bold',
          padding: '10px',
          borderColor: theme.palette.background.ternaryV2,
          boxShadow: 'none',
        },
        '.Tab--selected': {
          borderColor: theme.palette.background.ternaryV2,
          color: theme.palette.text.primary,
          boxShadow: 'none',
        },
        '.Tab--selected:hover': {
          borderColor: theme.palette.background.ternaryV2,
          boxShadow: 'none',
          color: theme.palette.text.primary,
        },
        '.Input': {
          background: `${theme.palette.background.primaryV2} !important`,
          padding: '12px',
          color: theme.palette.text.primary,
          borderColor: theme.palette.background.ternaryV2,
        },
        '.Input:hover': {
          background: `${theme.palette.background.primaryV2} !important`,
          borderColor: theme.palette.text.primary,
          boxShadow: 'none',
        },
        '.Input:focus': {
          background: `${theme.palette.background.primaryV2} !important`,
          borderColor: theme.palette.background.activeBorder,
          borderWidth: '2px',
          boxShadow: 'none',
          color: theme.palette.text.primary,
        },
        '.Label': {
          color: theme.palette.text.primary,
          fontSize: '12px',
          opacity: "1 !important"
        },
        '.fill-current ': {
          color: `${theme.palette.text.primary} !important`,
          opacity: "1 !important"
        },
        '.Checkbox': {
          color: `${theme.palette.text.primary} !important`,
          opacity: "1 !important"
        },
        '.CheckboxLabel': {
          color: `${theme.palette.text.primary} !important`,
          opacity: "1 !important"
        },
        '.TermsTextLabel': {  
          color: `${theme.palette.text.primary} !important`,
          opacity: "1 !important"
        },
        '.savedcardactive': {
          color: `${theme.palette.text.primary} !important`,
          opacity: "1 !important"
        },
        '.savedcardinactive input[type="radio"]::before': {
          borderColor: `${theme.palette.text.primary} !important`,
          opacity: "1 !important"
        },
        '.text-base': {
          color: `${theme.palette.text.primary} !important`,
          opacity: "1 !important"
        }
      },
    },
    branding: "never",
    displaySavedPaymentMethodsCheckbox: false,
    displaySavedPaymentMethods: displaySavedPaymentMethods,
    hideCardNicknameField: true,
    customMessageForCardTerms: "By providing your card information, you allow txt2create to charge your card for future payments in accordance with their terms."
  };

  return unifiedCheckoutOptions;
}